import React, { useState, useEffect, useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../../../../services/api';
import { moeda, virgulaPonto } from '../../../../util/util';
import ErpTemplate from '../../../../components/ErpTemplate';
import ReactSelect from '../../../../components/ReactSelect';
import { FaSave, FaTimes } from 'react-icons/fa';
import SaveButton from '../../../../components/SaveButton';


const CadastroParcelaPeriodica = () => {
    const { id } = useParams();
    const history = useHistory();
    console.log('CadastroParcelaPeriodica renderizado, id:', id, 'URL:', window.location.href);
    const [loading, setLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [saving, setSaving] = useState(false);
    const [participantes, setParticipantes] = useState([]);
    const [contas, setContas] = useState([]);
    const [caixas, setCaixas] = useState([]);

    const [formData, setFormData] = useState({
        periodicidade: 'mensal',
        dia_vencimento: '',
        mes_vencimento: '',
        data_inicio: '',
        data_fim: '',
        valor: '',
        participante_id: '',
        nomeParticipante: '',
        conta_id: '',
        nomeConta: '',
        caixa_id: '',
        nomeCaixa: '',
        descricao: '',
        observacao: '',
        situacao: 'ativa'
    });

    const carregarDados = useCallback(async () => {
        try {
            setLoading(true);

            // Carregar participantes
            const participantesResponse = await api({
                method: 'get',
                action: '/participante',
                token: localStorage.getItem('token')
            });
            if (participantesResponse.data && participantesResponse.data.status) {
                setParticipantes(participantesResponse.data.data || []);
            }

            // Carregar contas
            const contasResponse = await api({
                method: 'get',
                action: '/financeiroPlanoConta',
                token: localStorage.getItem('token')
            });
            if (contasResponse.data && contasResponse.data.status) {
                setContas(contasResponse.data.data || []);
            }

            // Carregar caixas
            const caixasResponse = await api({
                method: 'get',
                action: '/financeiroCaixa',
                token: localStorage.getItem('token')
            });
            if (caixasResponse.data && caixasResponse.data.status) {
                setCaixas(caixasResponse.data.data || []);
            }
        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            toast.error('Erro ao carregar dados');
        } finally {
            setLoading(false);
        }
    }, []);

    const carregarParcelaPeriodica = useCallback(async () => {
        try {
            setLoading(true);
            const response = await api({
                method: 'get',
                action: `/financeiroParcelaPeriodica/${id}`,
                token: localStorage.getItem('token')
            });

            if (response.data && response.data.status) {
                const data = response.data.data;
                console.log('Dados da parcela periódica:', data);

                // Armazenar os dados dos relacionamentos
                setFormData(prev => ({
                    ...prev,
                    participante_id: data.participante_id || '',
                    nomeParticipante: data.participante ? `${data.participante.codigo} - ${data.participante.nomefantasia || data.participante.nome || data.participante.contato}` : '',
                    conta_id: data.conta_id || '',
                    nomeConta: data.conta ? `${data.conta.caminho} - ${data.conta.nome}` : '',
                    caixa_id: data.caixa_id || '',
                    nomeCaixa: data.caixa ? data.caixa.nome : '',
                    descricao: data.descricao || '',
                    observacao: data.observacao || '',
                    situacao: data.situacao || 'ativa',
                    periodicidade: data.periodicidade || 'mensal',
                    dia_vencimento: data.dia_vencimento || '',
                    mes_vencimento: data.mes_vencimento || '',
                    data_inicio: data.data_inicio || '',
                    data_fim: data.data_fim || '',
                    valor: data.valor || '',
                }));
            } else {
                toast.error('Erro ao carregar parcela periódica');
            }
        } catch (error) {
            console.error('Erro:', error);
            toast.error('Erro ao carregar parcela periódica');
        } finally {
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        carregarDados();
        if (id) {
            carregarParcelaPeriodica();
        }
    }, [carregarDados, carregarParcelaPeriodica, id]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validarFormulario = () => {
        if (!formData.descricao.trim()) {
            toast.error('Descrição é obrigatória');
            return false;
        }

        if (!formData.valor || parseFloat(formData.valor) <= 0) {
            toast.error('Valor deve ser maior que zero');
            return false;
        }

        if (!formData.participante_id) {
            toast.error('Favorecido é obrigatório');
            return false;
        }

        if (!formData.conta_id) {
            toast.error('Conta é obrigatória');
            return false;
        }

        if (!formData.caixa_id) {
            toast.error('Caixa é obrigatório');
            return false;
        }

        if (!formData.dia_vencimento) {
            toast.error('Dia de vencimento é obrigatório');
            return false;
        }

        if (formData.periodicidade === 'anual' && !formData.mes_vencimento) {
            toast.error('Mês de vencimento é obrigatório para periodicidade anual');
            return false;
        }

        if (!formData.data_inicio) {
            toast.error('Data de início é obrigatória');
            return false;
        }

        if (!formData.data_fim) {
            toast.error('Data de fim é obrigatória');
            return false;
        }

        if (new Date(formData.data_inicio) >= new Date(formData.data_fim)) {
            toast.error('Data de fim deve ser posterior à data de início');
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        
        if (isSubmitting) {
            return;
        }

        if (!validarFormulario()) {
            return;
        }

        setIsSubmitting(true);

        try {
            setSaving(true);

            const dados = {
                ...formData,
                valor: virgulaPonto(formData.valor), // Converte para formato numérico
                empresa: localStorage.getItem('empresa')
            };

            const response = await api({
                method: id ? 'put' : 'post',
                action: id ? `/financeiroParcelaPeriodica/${id}` : '/financeiroParcelaPeriodica',
                token: localStorage.getItem('token'),
                data: dados
            });

            if (response.data && response.data.status) {
                toast.success(id ? 'Parcela periódica atualizada com sucesso' : 'Parcela periódica criada com sucesso');
                history.push({ pathname: '/financeiroParcelaPagar', state: { tab: 'periodicas' } });
            } else {
                toast.error('Erro ao salvar parcela periódica');
            }
        } catch (error) {
            console.error('Erro:', error);
            toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
        } finally {
            setIsSubmitting(false);
            setSaving(false);
        }
    };

    const handleCancelar = () => {
        history.push({ pathname: '/financeiroParcelaPagar', state: { tab: 'periodicas' } });
    };

    if (loading) {
        return (
            <ErpTemplate>
                <div className="main-content container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body text-center">
                                    <div className="spinner-border" role="status">
                                        <span className="sr-only">Carregando...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ErpTemplate>
        );
    }

    return (
        <ErpTemplate>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>{id ? 'Editar' : 'Nova'} Parcela Periódica</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <form className="form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Favorecido</label>
                                                        <ReactSelect
                                                            value={{ value: formData.participante_id, label: formData.nomeParticipante }}
                                                            onChange={e => setFormData({ ...formData, participante_id: e.value, nomeParticipante: e.label })}
                                                            defaultOptions
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/participante',
                                                                    token: localStorage.getItem('token'),
                                                                    params: {
                                                                        nome: input,
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map((registro) => {
                                                                            var label = registro.codigo +
                                                                                ' - ' + registro.nome +
                                                                                (registro.enderecomunicipio ? ' - ' + registro.enderecomunicipio.nome + '-' + registro.enderecomunicipio.uf : '') +
                                                                                (registro.cnpj ? ' (' + registro.cnpj + ')' : '') +
                                                                                (registro.cpf ? ' (' + registro.cpf + ')' : '') +
                                                                                (registro.nomefantasia ? ' - ' + registro.nomefantasia : '');
                                                                            return {
                                                                                value: registro.id,
                                                                                label: label
                                                                            };
                                                                        });
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    })
                .finally(() => {
                    setIsSubmitting(false);
                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Plano de Contas</label>
                                                        <ReactSelect
                                                            value={{ value: formData.conta_id, label: formData.nomeConta }}
                                                            onChange={e => setFormData({ ...formData, conta_id: e.value, nomeConta: e.label })}
                                                            defaultOptions
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/financeiroPlanoConta',
                                                                    token: localStorage.getItem('token'),
                                                                    params: {
                                                                        nome: input,
                                                                        tipo: "1",
                                                                        situacaoRegistro: "ativo",
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.caminho + ' - ' + registro.nome }));
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    })
                .finally(() => {
                    setIsSubmitting(false);
                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Caixa</label>
                                                        <ReactSelect
                                                            value={{ value: formData.caixa_id, label: formData.nomeCaixa }}
                                                            onChange={e => setFormData({ ...formData, caixa_id: e.value, nomeCaixa: e.label })}
                                                            defaultOptions
                                                            loadOptions={(input) => {
                                                                return api({
                                                                    method: 'get',
                                                                    action: '/financeiroCaixa',
                                                                    token: localStorage.getItem('token'),
                                                                    params: {
                                                                        nome: input,
                                                                    }
                                                                })
                                                                    .then(response => {
                                                                        let options = response.data.data.map(registro => ({ value: registro.id, label: registro.nome + (registro.cartaolimite > 0 ? " R$" + moeda(registro.cartaosaldo) : "") }));
                                                                        return options;
                                                                    })
                                                                    .catch(function (error) {
                                                                        //console.log(error);
                                                                    })
                .finally(() => {
                    setIsSubmitting(false);
                });
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Periodicidade</label>
                                                        <select
                                                            className="form-control"
                                                            name="periodicidade"
                                                            value={formData.periodicidade}
                                                            onChange={handleInputChange}
                                                            required
                                                        >
                                                            <option value="mensal">Mensal</option>
                                                            <option value="anual">Anual</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Dia de Vencimento</label>
                                                        <select
                                                            className="form-control"
                                                            name="dia_vencimento"
                                                            value={formData.dia_vencimento}
                                                            onChange={handleInputChange}
                                                            required
                                                        >
                                                            <option value="">Selecione o dia</option>
                                                            {Array.from({ length: 31 }, (_, i) => i + 1).map(dia => (
                                                                <option key={dia} value={dia}>{dia}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                {formData.periodicidade === 'anual' && (
                                                    <div className="col-sm-6">
                                                        <div className="form-group">
                                                            <label>Mês de Vencimento</label>
                                                            <select
                                                                className="form-control"
                                                                name="mes_vencimento"
                                                                value={formData.mes_vencimento}
                                                                onChange={handleInputChange}
                                                                required
                                                            >
                                                                <option value="">Selecione o mês</option>
                                                                {Array.from({ length: 12 }, (_, i) => i + 1).map(mes => (
                                                                    <option key={mes} value={mes}>{mes}</option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Data de Início</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="data_inicio"
                                                            value={formData.data_inicio}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Data de Fim</label>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            name="data_fim"
                                                            value={formData.data_fim}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label>Valor</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            name="valor"
                                                            value={formData.valor}
                                                            onChange={handleInputChange}
                                                            placeholder="0,00"
                                                            required
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-lg"
                                                            id="descricao"
                                                            placeholder="Descrição"
                                                            name="descricao"
                                                            value={formData.descricao}
                                                            onChange={handleInputChange}
                                                            required
                                                        />
                                                        <label htmlFor="descricao">Descrição</label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <div className="form-floating form-group">
                                                        <textarea
                                                            className="form-control form-control-lg"
                                                            id="observacao"
                                                            placeholder="Observações"
                                                            style={{ minHeight: "100px" }}
                                                            name="observacao"
                                                            value={formData.observacao}
                                                            onChange={handleInputChange}
                                                        />
                                                        <label htmlFor="observacao">Observações</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary me-1 mb-1"
                                                        onClick={handleCancelar}
                                                        disabled={saving}
                                                    >
                                                        <FaTimes size={20} /> Cancelar
                                                    </button>
                                                    <SaveButton isSubmitting={saving || isSubmitting} />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </ErpTemplate>
    );
};

export default CadastroParcelaPeriodica;
